var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/x-recipient-preview.ts
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { css } from "@adornis/chemistry/directives/css.js";
import { html, nothing } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { generateRecipientsPreview } from "../db/recipient-helpers.js";
var XRecipientPreview = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.recipients = [];
    this.maxLength = 50;
    this.truncateRecipients = true;
  }
  render() {
    if (!this.recipients.length)
      return nothing;
    const { displayedMailAddresses, truncatedCount, allMailAddresses } = generateRecipientsPreview(
      this.recipients,
      this.maxLength
    );
    return html`
      <x-flex space="xs">
        <x-text>
          ${this.truncateRecipients ? displayedMailAddresses.join(", ") : allMailAddresses.join(", ")}
          ${truncatedCount ? html`... ${this.toggleButton(truncatedCount)}` : nothing}
        </x-text>
      </x-flex>
    `;
  }
  toggleButton(truncatedCount) {
    const text = this.truncateRecipients ? `+ ${truncatedCount} weitere anzeigen` : "weniger anzeigen";
    return html`
      <x-text
        ${css({ display: "inline-block", color: this.colors.accent, cursor: "pointer" })}
        @click=${() => this.truncateRecipients = !this.truncateRecipients}
      >
        ${text}
      </x-text>
    `;
  }
};
__decorateClass([
  property({ type: Array, attribute: false })
], XRecipientPreview.prototype, "recipients", 2);
__decorateClass([
  property({ type: Number })
], XRecipientPreview.prototype, "maxLength", 2);
__decorateClass([
  state()
], XRecipientPreview.prototype, "truncateRecipients", 2);
XRecipientPreview = __decorateClass([
  customElement("x-recipient-preview")
], XRecipientPreview);
export {
  XRecipientPreview
};
